'use strict';

//React/Components
import React from 'react';
import RadioInput from '../Common/RadioInput.jsx';
import ContentService from '../../services/ContentService.js';

//Constants
import ApplicationConstants from '../../constants/ApplicationConstants';
const YesNoData = ApplicationConstants.YesNoValues;
const YesNoRadioData = [{ id: true, name: YesNoData.YES_LONG, isHidden: false }, { id: false, name: YesNoData.NO_LONG, isHidden: false }];

//Action
import YourDetailsActions from '../../actions/YourDetailsActions';

export default class PowerOfAttorney extends React.Component {
    constructor(props) {
        super(props);
    }

    updatePowerOfAttorneyData(index, event) {
        YourDetailsActions.updateYourDetailsData(event.target.model, event.target.id, event.target.value === 'true', index);
    }

    render() {
        let value = this.props.data;

        return (<RadioInput id="isPowerOfAttorney"
                data={YesNoRadioData}
                value={value}
                onChange={this.updatePowerOfAttorneyData.bind(this, this.props.index)}
                model="isPowerOfAttorney"
                label={ContentService.getContent().powerOfAttorney.label} />
        );
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/PowerOfAttorney.jsx